import React, { Component } from "react"
import { Radio, Checkbox, Row, Col } from "antd"
import { connect } from "react-redux"
import "./MenuItem.scss"
import {
  addOrRemoveItem,
  saveInstructionsToItem,
} from "../../redux/actionCreators/planDinnner"
import { addSelectedItemOptions } from "../../redux/actionCreators/planDinnner"
import {
  ADD_ITEM_BUTTON,
  CLOSE_BUTTON,
  PRICE,
  UPDATE_ITEM_BUTTON,
  PLUS_BUTTON,
  MINUS_BUTTON,
  SPECIAL_INSTRUCTIONS,
  INSTRUCTIONS_PLACEHOLDER,
  MENU_SUGGESTION_ACCEPTED,
} from "../../constants/messages"
import {
  FirebaseContext,
  FIREBASE_STATE_KEYS,
  FirebaseService,
} from "../../firebase"
import _ from "../../utils/lodashUtils"
import {
  CustomModal as Modal,
  Button,
  TextTag as Text,
  TextArea,
  TextTag,
} from "../../atoms"
import { saveSuggestionEvent } from "../../redux/actionCreators/planDinnner"
import { SUGGESTION_STATES } from "../../constants/commons"
import { getQuantityDescription } from "../../utils/helpers"

//popup for inner selection of menu items
class Menuitem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: this.props.showAddToCartPopup,
      selectedItem: this.props.menuItemInAddToCartPopup,
      quantity:
        this.props.menuItemInAddToCartPopup.quantity ||
        this.props.menuItemInAddToCartPopup.min_qty,
      selectedOptions: this.props.selectedItemOptions,
      instructions: this.props.menuItemInAddToCartPopup.instructions || "",
      validCart: false,
    }
    this.mandatorySubItem = []
  }
  static contextType = FirebaseContext

  componentDidMount() {
    // if no child menu options are present, it is required that we directly add unit item to cart.
    // for that, we validate the cart. If found valid, we check for childOptions.
    // if childOptions are empty, just close the modal, and fire the add item API call.
    const isCartValid = this.calculateCartValidity()
    if (isCartValid && !this.props.isUpdate) {
      const childOptions = this.getChilds()
      if (_.isEmpty(childOptions)) {
        this.props.closePopup()
        this.handleOk()
      }
    }
  }
  onSaveSuggestion = value => {
    const { user, partner, saveSuggestionEvent } = this.props
    const { dateState } = this.context
    const acceptedRestaurant = _.get(
      dateState,
      FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
      {}
    )
    const suggestedValue = {
      suggestedBy: _.get(partner, "username", ""),
      suggestedTo: _.get(user, "username", ""),
      type: "menu",
      id: acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
      menu: _.get(this.state, "selectedItem.name", ""),
      isAccepted: value,
      partner1Location: _.get(partner, "address.user_address", ""),
      partner2Location: _.get(user, "address.user_address", ""),
      date: new Date(),
    }
    saveSuggestionEvent(suggestedValue, () => {
      FirebaseService.write(
        true,
        `${FirebaseService.getDefaultPath()}${partner.uuid}/${
          FIREBASE_STATE_KEYS.UNREAD_NOTIFICATION
        }`
      )
    })
  }

  onRadioChange = (event, parentName) => {
    const currentSelectedOptions = { ...this.state.selectedOptions }
    currentSelectedOptions[parentName] = [event.target.value]
    this.setState({ selectedOptions: currentSelectedOptions })
    this.calculateCartValidity(currentSelectedOptions)
  }

  //if all required items are added, then allow item to be added to cart
  calculateCartValidity = (currentSelectedOptions, minQty, maxQty) => {
    const { mandatorySubItem } = this
    const { selectedOptions } = this.state
    if (!currentSelectedOptions) {
      currentSelectedOptions = selectedOptions
    }
    const validCart = minQty
      ? mandatorySubItem.every(
          subItemName =>
            currentSelectedOptions[subItemName] &&
            (currentSelectedOptions[subItemName].length === minQty ||
              currentSelectedOptions[subItemName].length === maxQty)
        )
      : mandatorySubItem.every(
          subItemName => currentSelectedOptions[subItemName]
        )

    this.setState({ validCart })
    return validCart
  }

  //for optional items or required if multiple options can be selected
  onCheckBoxChange = (event, parentName, minQty, maxQty) => {
    const currentSelectedOptions = { ...this.state.selectedOptions }
    if (event.target.checked) {
      if (!currentSelectedOptions[parentName]) {
        currentSelectedOptions[parentName] = []
      }
      currentSelectedOptions[parentName].push(event.target.value)
    } else {
      const itemIndex = currentSelectedOptions[parentName].indexOf(
        event.target.value
      )
      currentSelectedOptions[parentName].splice(itemIndex, 1)
    }
    this.setState({ selectedOptions: currentSelectedOptions })
    if (minQty >= 1)
      this.calculateCartValidity(currentSelectedOptions, minQty, maxQty)
  }

  //add item to cart or update
  handleOk = async () => {
    const { dateState, partnerState } = this.context
    const partnerUuid = _.get(partnerState, "userDetails.uuid")
    const partnerSuggestions = _.get(
      partnerState,
      FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
      {}
    )

    const acceptedRestaurant = _.get(
      dateState,
      FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
      {}
    )
    const options = {}
    const { selectedOptions } = this.state
    for (let key in selectedOptions) {
      for (let item of selectedOptions[key]) {
        options[item] = this.getOptionCount(key, item)
      }
    }
    const item = this.state.selectedItem
    const itemSuggestion = _.get(
      partnerSuggestions,
      `${item.id}.${FIREBASE_STATE_KEYS.SUGGESTION_STATE}`
    )
    const pendingSuggest = itemSuggestion === SUGGESTION_STATES.PENDING
    if (this.props.isUpdate) {
      const payload = {
        restaurant_id: acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
        item: {
          item_id: item.id,
          item_qty: this.state.quantity,
          option_qty: options,
          item_label: item.item_label,
          instructions: this.state.instructions,
        },
        cart_index: item.item_key,
      }
      this.props.saveInstructionsToItem(payload)
    } else {
      const payload = {
        item_id: item.id,
        item_qty: this.state.quantity,
        option_qty: options,
        instructions: this.state.instructions,
        item_label: "",
      }
      let updateFirebaseData = {}
      if (pendingSuggest) {
        const path = `${this.props.partner.uuid}/${FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER}/${item.id}/${FIREBASE_STATE_KEYS.SUGGESTION_STATE}`
        updateFirebaseData[path] = SUGGESTION_STATES.ACCEPTED
        updateFirebaseData[
          `${this.props.partner.uuid}/${FIREBASE_STATE_KEYS.CART_NOTIFICATION}`
        ] = {
          [FIREBASE_STATE_KEYS.INDICATOR]: true,
          [FIREBASE_STATE_KEYS.MESSAGE]: MENU_SUGGESTION_ACCEPTED,
          [FIREBASE_STATE_KEYS.TIMESTAMP]: Date.now(),
        }
      }
      await this.props.addOrRemoveItem(
        {
          payload,
          itemName: item.name,
          operation: "+",
          item,
        },
        acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
        updateFirebaseData
      )
      if (pendingSuggest) {
        this.onSaveSuggestion(true, () => {
          FirebaseService.write(
            true,
            `${FirebaseService.getDefaultPath()}${partnerUuid}/${
              FIREBASE_STATE_KEYS.UNREAD_NOTIFICATION
            }`
          )
        })
      }
    }
  }

  handleCancel = () => {
    this.props.closePopup()
    const { partnerState } = this.context
    const item = this.state.selectedItem
    const partnerSuggestions = _.get(
      partnerState,
      FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
      {}
    )
    const itemSuggestion = _.get(
      partnerSuggestions,
      `${item.id}.${FIREBASE_STATE_KEYS.SUGGESTION_STATE}`
    )
    const pendingSuggest = itemSuggestion === SUGGESTION_STATES.PENDING
    if (pendingSuggest) {
      this.props.onRejectSuggestion(item)()
    }
    // const { onRejectSuggestion, isUpdate, isSuggested } = this.props
    // if (
    //   !isUpdate &&
    //   onRejectSuggestion &&
    //   isSuggested(this.state.selectedItem)
    // ) {
    //   this.props.onRejectSuggestion(this.state.selectedItem)()
    // }
  }
  handleInstruction = ({ target: { value } }) => {
    this.setState({ instructions: value })
  }
  handleQuantityChange = operation => {
    let prevQuantity = this.state.quantity
    if (operation === "+" && prevQuantity < this.state.selectedItem.max_qty) {
      prevQuantity += 1
    } else if (
      operation === "-" &&
      prevQuantity > this.state.selectedItem.min_qty
    ) {
      prevQuantity -= 1
    }
    this.setState({ quantity: prevQuantity })
  }

  setMandatorySubItems = mandatorySubItem => {
    if (this.mandatorySubItem.indexOf(mandatorySubItem) === -1) {
      this.mandatorySubItem.push(mandatorySubItem)
    }
  }
  handleOptionChange = (child, option, isAdd, minQty, maxQty) => {
    const { selectedOptions } = this.state
    const currentSelectedOptions = { ...selectedOptions }
    if (!currentSelectedOptions[child.id]) {
      currentSelectedOptions[child.id] = []
    }
    if (isAdd) {
      currentSelectedOptions[child.id].push(option.id)
    } else {
      const index = currentSelectedOptions[child.id].indexOf(option.id)
      if (index !== -1) {
        currentSelectedOptions[child.id].splice(
          currentSelectedOptions[child.id].indexOf(option.id),
          1
        )
      }
    }
    this.setState({ selectedOptions: currentSelectedOptions })
    this.calculateCartValidity(currentSelectedOptions, minQty, maxQty)
  }
  getOptionCount = (childId, optionId) => {
    const { selectedOptions } = this.state
    if (selectedOptions[childId]) {
      return selectedOptions[childId].filter(
        childItem => childItem === optionId
      ).length
    }
    return 0
  }
  renderRadioButton = child => {
    const { selectedOptions } = this.state
    return (
      <Radio.Group
        className="nested-custom-radio-group"
        value={selectedOptions[child.id] ? selectedOptions[child.id][0] : null}
        onChange={event => this.onRadioChange(event, child.id)}
      >
        {child.children.map(innerRadio => (
          <Row key={innerRadio.id}>
            <Col span={16}>
              <Radio value={innerRadio.id}>
                <Text textType="smallTextPrimary">{innerRadio.name}</Text>
              </Radio>
            </Col>
            <Col align="right" span={8}>
              <Text textType="smallTextPrimary">{PRICE(innerRadio.price)}</Text>
            </Col>
          </Row>
        ))}
      </Radio.Group>
    )
  }
  renderCheckBox = child => {
    const { selectedOptions } = this.state
    return (
      <Checkbox.Group
        className="nested-checkbox-group"
        value={selectedOptions[child.id]}
      >
        {child.min_selection >= 1 ? this.setMandatorySubItems(child.id) : null}
        {child.children &&
          child.children.map(innerChild => (
            <Row key={innerChild.id}>
              <Col span={16}>
                <Checkbox
                  value={innerChild.id}
                  onChange={event =>
                    this.onCheckBoxChange(
                      event,
                      child.id,
                      child.min_selection,
                      child.max_selection
                    )
                  }
                >
                  <Text textType="smallTextPrimary">{innerChild.name}</Text>
                </Checkbox>
              </Col>
              <Col>
                <Text textType="smallTextPrimary">
                  {PRICE(innerChild.price)}
                </Text>
              </Col>
            </Row>
          ))}
      </Checkbox.Group>
    )
  }
  renderNestedOptions = child => {
    // renders inner nested option for an option item.(as per delivery.com)
    if (_.get(child, "min_selection", 0) > 0) {
      this.setMandatorySubItems(child.id)
    }
    if (child.min_selection === 1 && child.max_selection === 1) {
      return this.renderRadioButton(child)
    } else {
      return this.renderCheckBox(child)
    }
  }

  getChilds = () => {
    const { selectedOptions } = this.state
    const childs =
      this.state.selectedItem.children &&
      this.state.selectedItem.children.map((child, index) => (
        <div key={index}>
          <Text textType="spaceName">{child.name}</Text>
          <div>
            {!!_.get(child, "min_selection", 0) &&
              this.setMandatorySubItems(child.id)}
            {child.children &&
              (child.min_selection === 1 && child.max_selection === 1 ? (
                <div>
                  <TextTag>
                    {getQuantityDescription(child.min_selection)}
                  </TextTag>
                  <Radio.Group
                    className="customRadioGroup"
                    value={
                      selectedOptions[child.id]
                        ? selectedOptions[child.id][0]
                        : null
                    }
                    onChange={event => this.onRadioChange(event, child.id)}
                  >
                    {child.children.map(innerRadio => (
                      <React.Fragment key={innerRadio.id}>
                        <Row key={innerRadio.id}>
                          <Col span={16}>
                            <Radio value={innerRadio.id}>
                              <Text textType="smallTextPrimary">
                                {innerRadio.name}
                              </Text>
                            </Radio>
                          </Col>
                          <Col align="right" span={8}>
                            <Text textType="smallTextPrimary">
                              {PRICE(innerRadio.price)}
                            </Text>
                          </Col>
                        </Row>
                        <Row key={`nested${innerRadio.id}`}>
                          <Col span={16}>
                            {selectedOptions[child.id] &&
                              selectedOptions[child.id][0] === innerRadio.id &&
                              _.get(innerRadio, "children", []).map(child => (
                                <div key={child.id}>
                                  <TextTag>{child.name}</TextTag>
                                  {this.renderNestedOptions(child)}
                                </div>
                              ))}
                          </Col>
                        </Row>
                      </React.Fragment>
                    ))}
                  </Radio.Group>
                </div>
              ) : child.min_selection > 1 ||
                child.children.length < child.max_selection ? (
                <React.Fragment>
                  <TextTag>
                    {getQuantityDescription(
                      child.min_selection,
                      child.max_selection,
                      child.children.length
                    )}
                  </TextTag>
                  {child.min_selection >= 1
                    ? this.setMandatorySubItems(child.id)
                    : null}
                  {child.children &&
                    child.children.map(innerChild => (
                      <div
                        className="multi-options"
                        key={`multi-option-${innerChild.id}`}
                      >
                        <div className="action-buttons">
                          <Button
                            onClick={() => {
                              this.handleOptionChange(
                                child,
                                innerChild,
                                true,
                                child.min_selection,
                                child.max_selection
                              )
                            }}
                          >
                            +
                          </Button>
                          {this.getOptionCount(child.id, innerChild.id)}
                          <Button
                            onClick={() => {
                              this.handleOptionChange(
                                child,
                                innerChild,
                                false,
                                child.min_selection,
                                child.max_selection
                              )
                            }}
                          >
                            -
                          </Button>
                        </div>
                        <div className="multi-option-name">
                          <Text textType="smallTextPrimary">
                            {innerChild.name}
                          </Text>
                        </div>
                        <div className="multi-option-price">
                          <Text textType="smallTextPrimary">
                            {PRICE(innerChild.price)}
                          </Text>
                        </div>
                      </div>
                    ))}
                </React.Fragment>
              ) : (
                <div>
                  <TextTag>
                    {getQuantityDescription(
                      child.min_selection,
                      child.max_selection,
                      child.children.length
                    )}
                  </TextTag>
                  <Checkbox.Group
                    className="customCheckBoxGroup"
                    value={selectedOptions[child.id]}
                  >
                    {child.min_selection >= 1
                      ? this.setMandatorySubItems(child.id)
                      : null}
                    {child.children &&
                      child.children.map(innerChild => (
                        <React.Fragment key={innerChild.id}>
                          <Row key={innerChild.id}>
                            <Col span={16}>
                              <Checkbox
                                value={innerChild.id}
                                onChange={event =>
                                  this.onCheckBoxChange(
                                    event,
                                    child.id,
                                    child.min_selection,
                                    child.max_selection
                                  )
                                }
                              >
                                <Text textType="smallTextPrimary">
                                  {innerChild.name}
                                </Text>
                              </Checkbox>
                            </Col>
                            <Col>
                              <Text textType="smallTextPrimary">
                                {PRICE(innerChild.price)}
                              </Text>
                            </Col>
                          </Row>
                          <Row key={`nested${innerChild.id}`}>
                            <Col span={16}>
                              {selectedOptions[child.id] &&
                                selectedOptions[child.id].indexOf(
                                  innerChild.id
                                ) !== -1 &&
                                _.get(innerChild, "children", []).map(child => (
                                  <div key={child.id}>
                                    <TextTag>{child.name}</TextTag>
                                    {this.renderNestedOptions(child)}
                                  </div>
                                ))}
                            </Col>
                          </Row>
                        </React.Fragment>
                      ))}
                  </Checkbox.Group>
                </div>
              ))}
          </div>
        </div>
      ))
    return childs
  }

  render() {
    const { cartOperationInProgress } = this.props
    const loadingProps = cartOperationInProgress ? { loading: true } : {}
    return (
      <div id="MenuItem">
        <Modal
          title={this.state.selectedItem && this.state.selectedItem.name}
          visible={this.state.visible}
          keyboard={false}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={[
            <div
              className="menu-item-footer-container"
              key={this.state.selectedItem.id}
            >
              <div className="special-instruction">
                <div className="instruction-header">{SPECIAL_INSTRUCTIONS}</div>
                <TextArea
                  value={this.state.instructions}
                  className="instruction-input"
                  placeholder={INSTRUCTIONS_PLACEHOLDER}
                  onChange={this.handleInstruction}
                />
              </div>
              <div key="footer" className="menuItemAddCartFooter">
                <div className="add-remove-item">
                  <Button
                    className="add-remove-btn"
                    onClick={() => this.handleQuantityChange("-")}
                  >
                    {MINUS_BUTTON}
                  </Button>
                  <Text className="menuItemQuantity">
                    {this.state.quantity}
                  </Text>
                  <Button
                    className="add-remove-btn"
                    onClick={() => this.handleQuantityChange("+")}
                  >
                    {PLUS_BUTTON}
                  </Button>
                </div>
                <div className="add-close-item-footer">
                  <Button
                    key="back"
                    btnType="bordered"
                    onClick={this.handleCancel}
                  >
                    {CLOSE_BUTTON}
                  </Button>

                  <Button
                    key="submit"
                    type="primary"
                    disabled={!this.state.validCart}
                    onClick={this.handleOk}
                    {...loadingProps}
                  >
                    {this.props.isUpdate ? UPDATE_ITEM_BUTTON : ADD_ITEM_BUTTON}
                  </Button>
                </div>
              </div>
            </div>,
          ]}
        >
          {this.getChilds()}
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    suggestedBtn: state.planDinner.whichItemAreSuggested,
    user: _.get(state, "auth.user", {}),
    partner: _.get(state, "auth.partner", {}),
    showAddToCartPopup: state.planDinner.showAddToCartPopup,
    menuItemInAddToCartPopup: state.planDinner.menuItemInAddToCartPopup,
    selectedItemOptions: _.get(state, "planDinner.selectedItemOptions", {}),
    isUpdate: _.get(state, "planDinner.isUpdate", {}),
    cartOperationInProgress: _.get(
      state,
      "loadingState.itemOperationLoading",
      false
    ),
  }
}

export const MenuItem = connect(mapStateToProps, {
  addOrRemoveItem,
  addSelectedItemOptions,
  saveInstructionsToItem,
  saveSuggestionEvent,
})(Menuitem)
